import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useStyles } from './styles';
import { getPrivacySecurityContent } from '../../actions'
import { scrollTop } from '../../helpers';

export const Security = () => {
  const classes = useStyles();
  const [data, setData] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const res = await dispatch(getPrivacySecurityContent('PC007'));
    if (res && res.lstPageContentDetails) {
      setData(res.lstPageContentDetails[0].contentValue);
      if (window.location.hash.includes('IdentityTheft')) {
        setTimeout(function () {
          window.scrollTo({ top: 1200, left: 0, behavior: 'smooth' });
        }, 1000);
      } else {
        scrollTop()
      }
    } else {
      setData('');
    }
  }

  if (data) {
    return (
      <Box className={classes.rootBg}>
        <Box className={classes.root}>
          <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Security & Privacy Resource Center</h1>
          <div dangerouslySetInnerHTML={{ __html: data }} />
        </Box>
      </Box>
    )
  } else {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    )
  }
}